import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, FormLabel, MenuItem, TextField } from "@mui/material";

import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";
import { withLocalizer } from "utilities/withLocalizer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BlockIcon from "@mui/icons-material/Block";

class Departure extends Component {
  
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.departureCitiesMasterData !== this.props.departureCitiesMasterData) {
            let { departureCitiesMasterData } = this.props;
            let productType = commonUtilities.getProductType(this.props);

            if (productType) {
                let departureCities = departureCitiesMasterData?.data
                    ? departureCitiesMasterData?.data || []
                    : [];

                if (departureCities?.length === 1) {
                    if (!this.props?.data?.isClone) {
                        this.handleData(null, departureCities[0]);
                    }
                }
            }
        }
    }

    handleData = (event, city) => {
        let { handleStep2Data, onDepartureChange } = this.props;

        let productType = commonUtilities.getProductType(this.props);

        const { departure } = productType;

        departure.code = (city) ? city.code : "";
        departure.name = (city) ? city.name : "";
        departure.providerCode = (city) ? city.providerCode : "";

        handleStep2Data({ ...productType });
        onDepartureChange();
    };

    render() {
        let { departureCitiesMasterData, error } = this.props;
        let productType = commonUtilities.getProductType(this.props);

        if (!productType) return;
        const { departure, destination } = productType;
        let departureCities = departureCitiesMasterData?.data
            ? departureCitiesMasterData?.data || []
            : [];

        let selectPlaceHolder = this.props.localize("qma-select-label");
    
        const enabled = !(destination.code === "" || !(departureCities?.length > 0));

        return (
            <div className={"row departure-wrapper form-control-wrapper" + (enabled ? "" : " disabled")}>
                <FormLabel>
                    {this.props.localize("qma-departure-city")}
                </FormLabel>
                <Autocomplete
                    popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? (enabled ? <ExpandMoreIcon/>: <BlockIcon/>) : null}
                    disabled={!enabled}
                    autoHighlight
                    value={departure?.code ? departure : null}
                    onChange={(event, city) => this.handleData(event, city)}
                    options={departureCities}
                    isOptionEqualToValue={(option) =>
                        option.name === departure.name
                    }
                    getOptionLabel={(city) =>
                        city ? `${city.name} (${city.providerCode})` : ""
                    }
                    renderOption={(props, city, index) => (
                        <li {...props} keys={index}>
                            {city.name} ({city.code})
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            placeholder={selectPlaceHolder}
                            className={(error?.trim().length === 0) ? "formControl" : "errorControl formControl"}
                            {...params}
                        />
                    )}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    departureCitiesMasterData: state.departureCitiesMasterData
});

export default connect(mapStateToProps)(withLocalizer(Departure));
